<template>
  <div>
    <div v-if="ordreTravail.demandesLogistique.length === 0">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('addEditOrdreTravailTech.demandeLiee.noDemande.title')}}
          </h1>
          <a class="lien" @click="$emit('goToAddDemande')">
            {{ $t('addEditOrdreTravailTech.demandeLiee.noDemande.associe')}}
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns">
        <div class="column is-12">
          <div class="has-text-right">
            <button
              class="button is-primary"
              @click="$emit('goToAddDemande')">
              {{ $t('addEditOrdreTravailTech.demandeLiee.actions.lie') }}
            </button>
          </div>
        </div>
      </div>
      <div class="card">
        <header class="header-card">
          <p>{{ $t('addEditOrdreTravailTech.demandeLiee.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="card column is-12 mgb-20px"
                 v-for="(demande, index) in ordreTravail.demandesLogistique"
                 :key="index">
              <info-demande :demande-intervention="demande"
                            @deleteDemande="deleteDemande"
                            :ot="ordreTravail">
              </info-demande>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import infoDemande from '@/components/logistique/ordreTravail/tech/addEdit/demande/infoDemande';

export default {
  name: 'LogistiqueOrdreTravailTechniqueEditDemande',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    infoDemande,
  },
  methods: {
    deleteDemande(demandeId) {
      const indexDemandeIds = this.ordreTravail.demandesLogistiqueIds.findIndex((id) => {
        return id === demandeId;
      });
      if (indexDemandeIds > -1) this.ordreTravail.demandesLogistiqueIds.splice(indexDemandeIds, 1);
      const indexDemandes = this.ordreTravail.demandesLogistique.findIndex((d) => {
        return d.id === demandeId;
      });
      if (indexDemandes > -1) this.ordreTravail.demandesLogistique.splice(indexDemandes, 1);
    },
  },
};

</script>
